import { LunchroulettePage } from './../lunchroulette/lunchroulette';
import { Component } from '@angular/core';

import { HomePage } from '../home/home';
import { NetworkPage } from '../network/network';
import { NotificationsPage } from '../notifications/notifications';
import { PollPage } from '../poll/poll';
import { NotificationProvider } from '../../../providers/notification/notification';
import { AuthProvider } from '../../../providers/auth/auth';
import {MessagingPage} from "../messaging/messaging";
import {ProfilePage} from "../profile/profile";
import {MenuProfile} from "../menu-profile/menu-profile";

@Component({
  templateUrl: 'tabs.html'
})
export class TabsPage {

  tab1Root = HomePage;
  tab2Root = NetworkPage;
  tab3Root = LunchroulettePage;
  tab4Root = MessagingPage;
  tab5Root = MenuProfile;

  //
  notifications: number = 0;


    constructor(public notificationProvider: NotificationProvider, public authProvider: AuthProvider) {

  }

  ngOnInit() {
    this.notificationProvider.getAll().subscribe((res) => {
      if(res.success){

        res.data.forEach(notification => {

          notification.user_id != this.authProvider.user.user_id ? this.notifications++ : '';
        });
      }
  })
}


}



// WEBPACK FOOTER //
// ./src/pages/employee/tabs/tabs.ts